// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"673":"a6600a04136b1cd4333c","827":"156ae09c18cdc34846c8"}[chunkId] + ".js";
};